import React, { useEffect, useState } from 'react'
import { Statistic } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { BackButton, BasicInfoWrapper, BasicSettingWrapper, CustomSettingWrapper, SettingWrapper, SubTitle } from './targeting.styled'
import SegmentTable from './Component/SegmentTable'
import useParams from '../../hook/useParams'
import dayjs from 'dayjs'
import { fetchExport } from '../../apis/export'

function TargetPreview (props) {
  const { goBackPath } = props
  const { t: ln_t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { state } = location || {}
  const { data } = state || {}
  const { name, createdAt, creator, status, quantity, targetingDetail, dataExportId, segmentType } = data || {}
  const params = useParams()
  const { handleFetchParams } = params
  const [dataExport, setDataExport] = useState([])

  const getDataExp = async () => {
    const res = await fetchExport({ maxResults: 999 })
    if (res?.status === 200) setDataExport(res?.data)
  }
  useEffect(() => {
    if (!data) return navigate(goBackPath)
    getDataExp()
    handleFetchParams('add', { data: targetingDetail })
  }, [])

  const formatDate = (date, detail) => dayjs(date).format(detail ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY')
  return (
    <>
      <BackButton>
        <ArrowLeftOutlined onClick={() => navigate(goBackPath)} />
        {name}
      </BackButton>
      <SettingWrapper>
        <BasicSettingWrapper>
          <SubTitle>{ln_t('util.basicInfo')}</SubTitle>
          <div className="d-flex">
            <BasicInfoWrapper>
              <Statistic title={ln_t('util.name')} value={name || '-'} />
              <Statistic title={ln_t('util.createdAt')} value={formatDate(createdAt)} />
              <Statistic title={ln_t('util.creator')} value={creator?.name || '-'} />
            </BasicInfoWrapper>
            <BasicInfoWrapper>
              <Statistic title={ln_t('target.totalQuantity')} value={quantity} />
              <Statistic title={ln_t('target.segmentCount')} value={targetingDetail?.length || 0} />
              <Statistic title={ln_t('util.status')} value={status ? ln_t('util.enable') : ln_t('util.disable')} />
            </BasicInfoWrapper>
          </div>
          <BasicInfoWrapper style={{ margin: '16px 0 40px', width: '100%' }}>
            <Statistic title={ln_t('target.dataExport')} value={dataExport?.find(i => i?.id === dataExportId)?.name || '-'} />
          </BasicInfoWrapper>
        </BasicSettingWrapper>
        <CustomSettingWrapper>
          <SubTitle style={{ paddingBottom: '8px' }}>{ln_t('segment.segment')} {ln_t('target.detail')}</SubTitle>
          <SegmentTable segmentParams={params} dataExport={dataExport} segmentKey={segmentType === 'invoice' ? 'invoiceSegment' : 'segment'} />
        </CustomSettingWrapper>
      </SettingWrapper>
    </>
  )
}

export default TargetPreview
